import React from "react";
import Popover from "@mui/material/Popover";

const MenuPopover = ({ children, open, onClose, id, anchorEl }) => {
  return (
    <Popover
      id={id}
      open={Boolean(open)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 58,
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        "& .MuiPopover-paper": {
          borderRadius: 4,
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default MenuPopover;
